/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, signal } from '@angular/core';
import { ColumnDatatable } from './models/columnDatatable.model';

@Component({
  template: `<span
    class="text-sm text-[var(--p-text-700)]"
    [ngStyle]="{
      'font-weight': textInBold(),
    }"
    >{{ renderValue() }}</span
  >`,
})
export class BaseDatatableCellComponent {
  value = signal<any>(null);
  rowData = signal<any>(null);
  colDef = signal<ColumnDatatable<any>>({ field: '', headerName: '' });
  index = signal<number>(0);

  textInBold() {
    if (typeof this.colDef().bold === 'boolean' && this.colDef().bold)
      return 'bold';

    if (
      typeof this.colDef().bold === 'function' &&
      this.colDef().bold?.(this.rowData(), this.index())
    ) {
      return 'bold';
    }

    return undefined;
  }

  renderValue() {
    return this.colDef().element
      ? this.colDef().element?.(this.rowData(), this.index())
      : this.value();
  }
}
